import {
  Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto,
  Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto,
  Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto,
} from '@/services/wealthlane-award-services';
import { CsBrokerTradeToolService } from '@/services/wealthlane-award-services/services/CsBrokerTradeToolService';
import { type UseQueryResult, useQuery } from 'react-query';

const useGetAwardDetailsByIdForBrokerTool = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string,
  awardType?: string,
  companyId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | Wealthlane_AwardService_Dtos_PSUAward_PSUAwardOverviewDto
  | Wealthlane_AwardService_Dtos_RSUAward_RSUAwardOverviewDto
  | Wealthlane_AwardService_Dtos_OptionAward_OptionAwardOverviewDto
  | undefined,
  unknown
> => {
  console.log('id', id);
  console.log('awardType', awardType);
  console.log('companyId', companyId);
  const awardDetailsByIdForBrokerTool = useQuery(
    ['awardDetailsByIdForBrokerTool', id, awardType, companyId],
    async () => {
      if (id && awardType === 'RSU') {
        return await handleRequest(
          CsBrokerTradeToolService.getApiAwardApiAppCsBrokerTradeToolRsuAwardVestingDate(
            companyId,
            id
          )
        );
      }
      if (id && awardType === 'PSU') {
        return await handleRequest(
          CsBrokerTradeToolService.getApiAwardApiAppCsBrokerTradeToolPsuAwardVestingDate(
            companyId,
            id
          )
        );
      }
      if (id && (awardType === 'Options' || awardType === 'ISO' || awardType === 'NQSO')) {
        return await handleRequest(
          CsBrokerTradeToolService.getApiAwardApiAppCsBrokerTradeToolOptionAwardOverview(
            companyId,
            id
          )
        );
      }
    },
    { enabled: !!id }
  );

  return awardDetailsByIdForBrokerTool;
};

export default useGetAwardDetailsByIdForBrokerTool;
